import MARKETS from './markets'
import OLD_ROUTES from './oldRoutes'
import SOURCE_ROUTES from './sourceRoutes'

export default {
  ...MARKETS,
  ...OLD_ROUTES,
  ...SOURCE_ROUTES,
}
